var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.75L5.875 2L5.125 1.625L5.875 1.25L6.25 0.5L6.625 1.25L7.375 1.625L6.625 2L6.25 2.75ZM2.875 4.25L2.24219 3.00781L1 2.375L2.24219 1.76562L2.875 0.5L3.48438 1.76562L4.75 2.375L3.48438 3.00781L2.875 4.25ZM2.875 2C2.66406 2 2.5 2.1875 2.5 2.375C2.5 2.58594 2.66406 2.75 2.875 2.75C3.0625 2.75 3.25 2.58594 3.25 2.375C3.25 2.1875 3.0625 2 2.875 2ZM11.125 7.25L11.7344 8.51562L13 9.125L11.7344 9.75781L11.125 11L10.4922 9.75781L9.25 9.125L10.4922 8.51562L11.125 7.25ZM11.125 9.5C11.3125 9.5 11.5 9.33594 11.5 9.125C11.5 8.9375 11.3125 8.75 11.125 8.75C10.9141 8.75 10.75 8.9375 10.75 9.125C10.75 9.33594 10.9141 9.5 11.125 9.5ZM12.7656 2.32812C13.0703 2.63281 13.0703 3.10156 12.7656 3.40625L3.88281 12.2891C3.71875 12.4297 3.53125 12.5 3.34375 12.5C3.15625 12.5 2.96875 12.4297 2.80469 12.2891L1.21094 10.6953C0.90625 10.3906 0.90625 9.92188 1.21094 9.61719L10.0938 0.734375C10.2578 0.59375 10.4453 0.5 10.6328 0.5C10.8203 0.5 11.0078 0.59375 11.1719 0.734375L12.7656 2.32812ZM3.34375 11.75L9.39062 5.70312L7.79688 4.10938L1.75 10.1562L3.34375 11.75ZM9.92969 5.16406L12.25 2.86719L10.6328 1.25L8.33594 3.57031L9.92969 5.16406Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintIcon);
export default __webpack_public_path__ + "static/media/mintIcon.19266a43ad486cdefa7d84c2a03f8533.svg";
export { ForwardRef as ReactComponent };